import { render, staticRenderFns } from "./ColumnChart.component.vue?vue&type=template&id=062d9849&"
import script from "./ColumnChart.component.vue?vue&type=script&lang=js&"
export * from "./ColumnChart.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports